import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// Same default brand color denzo-web-app falls back to (src/Theme.js) when a
// store hasn't customized its own theme_color — kept as a plain constant here
// rather than reading localStorage['str'], since a waiter app has no public
// storefront theme to inherit; wire this up to store.theme_color from the
// pos/v1/init response later if per-store branding is wanted here too.
const BRAND_COLOR = "#c62828";

let theme = createTheme({
  shape: { borderRadius: 10 },
  palette: {
    primary: { main: BRAND_COLOR, contrastText: "#fff" },
    background: { default: "#faf7f5" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
export { BRAND_COLOR };
